import React, { useEffect, useState } from "react";
import { InfoSection } from "../../components";
import ContactUs from "../Contact/ContactUs";
import TextDisplay from "../../components/TextDisplay/TextDisplay";
import ImageSlider from "../../components/Slider/Slider";
import SingleImage from "../../components/SingleImage/SingleImage";
import UserDirectory from "../../components/Userdirectory/Userdirectory";

function Home() {
  const [data, setdata] = useState([]);
  const [userData, setUserData] = useState(null);

  const GetImageData = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
      ActiveStatus: "A",
      Type: "Zangie_DynamicWebsite",
    };

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Bill/Getwebsitedatadynamic`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );

      const data = await response.json();

      const convertBooleans = (obj) => {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => {
            if (value === "true") return [key, true];
            if (value === "false") return [key, false];
            return [key, value];
          }),
        );
      };

      let convertedData;
      if (Array.isArray(data)) {
        convertedData = data.map(convertBooleans);
      } else {
        convertedData = convertBooleans(data);
      }

      setdata(convertedData);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const fetchUserData = async (OrgID) => {
    const sendData2 = {
      OrgId: OrgID,
      Skip: 0,
      Take: 100,
    };

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/FLOW/GetusersZangie`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );
      const data = await response.json();
      //console.log("Data: ", data)
      setUserData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const sendData2 = {
        ActualWebsite: window.location.hostname,
        //ActualWebsite:"bajrangseva.com",
        //ActualWebsite: "eh.mounts.in",
        //ActualWebsite: "healcop.com",
        //ActualWebsite: "dev-lok.com",
        OrgName: "test",
      };

      try {
        await fetch(
          `https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData2),
          },
        )
          .then((response) => response.json())
          .then((data) => {
              console.log("Data: ", data)
            const orgid = data.orgId;
            GetImageData(orgid);
            fetchUserData(orgid);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const getEmbedUrl = (url) => {
    if (!url) return "";
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (url.includes("youtube.com/watch")) {
      const videoId = new URL(url).searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (url.includes("youtube.com/embed")) {
      return url.split("?")[0];
    }
    return url;
  };

  const renderItem = (item, index) => {
    switch (item.description) {
      case "ZangieImageGallary":
        return null;

      case "ZangieMembers":
        return userData &&
          (userData.users || []).filter((u) => u.url === "true").length > 0 ? (
          <div key={index} style={{ background: "#f9fafb", padding: "20px 0" }}>
            <UserDirectory userData={userData} />
          </div>
        ) : null;

      case "ZangieVideo":
        return (
          <div key={index} style={{ padding: "40px 20px", background: "#fff" }}>
            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
                overflow: "hidden",
                maxWidth: "900px",
                margin: "0 auto",
                borderRadius: "12px",
              }}
            >
              <iframe
                src={`${getEmbedUrl(item.alt)}?controls=1&rel=0`}
                title="YouTube Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                }}
              />
            </div>
          </div>
        );

      case "ZangieImage":
        return <SingleImage key={index} data={item} />;

      default:
        if (
          item.img ===
          "https://mountsfileupload.azurewebsites.net/api/FileUpload/"
        ) {
          return <TextDisplay key={index} data={[item]} />;
        }
        return <InfoSection key={index} {...item} />;
    }
  };

  return (
    <>
      {data.filter((s) => s.description === "ZangieImageGallary").length >
        0 && (
        <ImageSlider
          data={data.filter((s) => s.description === "ZangieImageGallary")}
        />
      )}

      {data.map((item, index) => renderItem(item, index))}

      <ContactUs />
    </>
  );
}

export default Home;
